module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "landing-github"
  }, [_c('div', {
    staticClass: "inner-container"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("\n      Projetos que desenvolvemos\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "repo-list "
  }, _vm._l((_vm.firstSixReposByStar), function(repo, index) {
    return _c('li', {
      staticClass: " repo-item"
    }, [_c('h3', [_vm._v("\n          " + _vm._s(repo.full_name.replace('moip/', '').replace(/-/g, ' ')) + "\n        ")]), _vm._v(" "), _c('p', {
      staticClass: "repo-rating"
    }, [_c('span', {
      staticClass: "moip-icon moip-icon-code-fork"
    }), _vm._v("\n          " + _vm._s(repo.forks_count) + "\n          "), _c('span', {
      staticClass: "moip-icon moip-icon-star"
    }), _vm._v("\n          " + _vm._s(repo.stargazers_count) + "\n        ")]), _vm._v(" "), _c('round-button', {
      staticClass: "purple show-project",
      attrs: {
        "href": "https://github.com/moip",
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "moip-icon moip-icon-github"
    }), _vm._v("\n          Ver projeto\n        ")])], 1)
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f589274!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingGithub.vue
// module id = 133
// module chunks = 1